import { useDeliveryApi } from "../../../common/api/delivery-api/useDeliveryApi";

export const useDeliveryBucketsApi = () => {
    const {
        createKeyBasedDeliveryBucket,
        createRoleBasedDeliveryBucket,
        deleteDeliveryBucket,
        validateUniqueId,
        getDeliveryBucketList,
        disableDeliveryBucket,
        enableDeliveryBucket,
        inviteToDeliveryBucket
    } = useDeliveryApi();

    return {
        createKeyBasedDeliveryBucket,
        createRoleBasedDeliveryBucket,
        deleteDeliveryBucket,
        validateUniqueId,
        getDeliveryBucketList,
        disableDeliveryBucket,
        enableDeliveryBucket,
        inviteToDeliveryBucket
    };
};
